import gql from 'graphql-tag';
export const KinderConnectCaptureFlags = gql `
    query KinderConnectCaptureFlags($siteId: SiteId!) {
        attendance {
            childCheckins {
                kinderConnectCapture(siteId: $siteId) {
                    captureEnabled
                    captureRequired
                }
            }
        }
    }
`;
